import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import UserCreateModalSF from '../../../components/superUser/account/UserCreateModalSF.js'
import DirectorCreateModalSF from '../../../components/superUser/account/DirectorCreateModalSF.js'
import KYCNavUI from '../../../components/superUser/account/KYCNavUI.js'
import KYCUserListSF from '../../../components/superUser/account/KYCUserListSF.js'

const KYCUserListPageUI = ({ context, account, accountUserList,
  onRefreshClick, copyToClipboardText, onCopyToClipboard,
  createUserMode, onCancelCreateUser, onCreateUserClick,
  createDirectorMode, onCancelCreateDirector, onCreateDirectorClick,
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w768'
    centered={!account || !accountUserList} account={account} page='kyc'
  >
    {
      (!account || !accountUserList) &&
      <SpinnerComponentUI />
    }

    {
      account && accountUserList &&
      <div>
        <ActionLeftUI context={context} onRefreshClick={onRefreshClick}
          onCreateDirectorClick={onCreateDirectorClick} onCreateUserClick={onCreateUserClick}
        />
        <KYCNavUI account={account} page='directors' />
        <KYCUserListSF
          context={context}
          account={account}
          accountUserList={accountUserList}
          copyToClipboardText={copyToClipboardText}
          onCopyToClipboard={onCopyToClipboard}
          onRefreshClick={onRefreshClick}
        />

        <UserCreateModalSF context={context}
          onRefreshClick={onRefreshClick}
          createMode={createUserMode} onCancelCreate={onCancelCreateUser}
          account={account}
        />

        <DirectorCreateModalSF context={context}
          onRefreshClick={onRefreshClick}
          createMode={createDirectorMode} onCancelCreate={onCancelCreateDirector}
          account={account}
        />
      </div>
    }

  </SuperUserAccountPageUI>

const ActionLeftUI = ({ context, onRefreshClick, onCreateDirectorClick, onCreateUserClick }) =>
  <div className='g_flex_h g_flex_left'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
    {
      context.permissions.includes('su_manage') &&
        <IconButtonUI icon='icon-user-plus' onClick={onCreateDirectorClick} label='Add director' />
    }
    {
      context.permissions.includes('su_manage') &&
        <IconButtonUI icon='icon-plus' onClick={onCreateUserClick} label='Add admin' />
    }
    <span className='g_m_left_100 g_large'><b>Know Your Customer</b></span>
  </div>

export default KYCUserListPageUI
